import React, { FC } from "react";

import { t } from "i18next";

import { isNotEmpty } from "@/core/string";
import { useStaticQuery } from "@/shared/apis/referenceApi";

import { RefType, staticTables } from "../utils";

type RefValueProps = {
    table: RefType;
    value: number | string;
    onEmpty?: string;
    onLoading?: string;
};

const RefValue: FC<RefValueProps> = ({ table, value, onEmpty = "-", onLoading = t("Common.Loading") }) => {
    const { options, loading } = useStaticQuery(staticTables[table].path);
    if (typeof value !== "number" && !isNotEmpty(value)) {
        return <>{onEmpty}</>;
    }
    if (loading) return <>{onLoading}</>;
    return <>{options.find((option) => option.id === value)?.name}</>;
};

export default RefValue;
